import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import StockReportLayer from "../components/StockReportLayer";
import usePermission from "../hook/usePermission";
import AccessDeniedLayer from "../components/AccessDeniedLayer";

const StockReportPage = () => {
    const hasPermission = usePermission("productReport", "view");
    return (
        <>
            <MasterLayout>
                <Breadcrumb title="Stock Transaction Report" header="Stock Transaction Report" />
                {hasPermission ? <StockReportLayer /> : <AccessDeniedLayer />}
            </MasterLayout>
        </>
    );
};

export default StockReportPage;
